import React, { useContext, useEffect, useState } from "react";
import { CrackersContext } from "../CrackersContext";
import { raisePostRequest } from "../AxiosAPI";
import { Col, Row } from "react-bootstrap";
import { dateTimeConverter, isSmScreen, isXSmScreen } from "../CrackersUtil";
import { Link } from "react-router-dom";

function Orders () {

    const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage } = useContext(CrackersContext);
    const [orders, setOrders] = useState([]);
    const [ordersExist, setOrdersExist] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    useEffect(() => {
        const orders = async () => {
            const response = await raisePostRequest(`/orders`, null, null, setShowErrorToastStatus, setToastBody);
            if(response) {
                if(response.length > 0) {
                    setOrders(response);
                    setOrdersExist(true);
                    setIsZeroCasePage(false);
                } else {
                    setOrders([]);
                    setOrdersExist(false);
                    setIsZeroCasePage(true);
                }
                
            }
        }
        orders();

        const handleResize = () => {
            setIsMobileView(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth));
        };
        setIsMobileView(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth));

        window.addEventListener('resize', handleResize);

    }, [])

    return (
        (ordersExist) ? (
            orders.map((order, index) => 
                <BuildOrder key={"order_" + index}
                            order={order}/>
            )
        ) : (
            <div className="ct-vw">
                <div className="center_of_scrn_empt_ct">
                    <h1>No orders found in your account.</h1>
                    <h5>Explore our <a href="/web/crackers">crackers</a> and place an order.</h5>
                </div>
            </div>
        )
    );
}

function BuildOrder({order}) {
    const [clHover, setClHover] = useState(false);
    const handleMouseOver = () => setClHover(true);
    const handleMouseOut = () => setClHover(false);

    const linkToDetailView = `/web/orders/${order.id}`

    const conatinerStyles = {
        // clHover ? 'skyblue 1px solid' : '#eee',
        border : clHover ? "skyblue solid 3px" : "blue solid 1px",
        margin: clHover ? "1px 1px" : "5px 5px",
        // backgroundColor : clHover ? "#eee" : "white",
        borderRadius : "10px"
    }

    const paymentStatus = () => {
        switch(order.payment_status) {
            default:
            case 0:
                return (<><span style={{color : "red"}}>Unpaid</span></>);
            case 1:
                return (<><span style={{color : "orange"}}>Waiting for payment Approval</span></>);
            case 2:
                return (<><span style={{color : "#4CAF50"}}>Paid</span></>);
        }
    }

    const paymentId = () => {
        if(order.payment_id) {
            return order.payment_id;
        } else {
            return "NA";
        }
    }

    const paymentConfirmation = () => {
        if(order.payment_confirmation_time) {
            return (<><span style={{color : "green"}}>Confirmed</span></>);
            // return dateTimeConverter(order.payment_confirmation_time);
        } else {
            return (<><span style={{color : "red"}}>Not Confirmed</span></>);
        }
    }

    const dispatchStatus = () => {
        switch(order.dispatch_status) {
            default:
            case 0:
                return (<><span>Waiting for payment/confirmation</span></>);
            case 1:
                return (<><span style={{color : "orange"}}>Approved and Queued</span></>);
            case 2:
                return (<><span style={{color : "orange"}}>Prepared</span></>);
            case 3:
                return (<><span style={{color : "#4CAF50"}}>Dispatched</span></>);
            case 4:
                return (<><span style={{color : "#4CAF50"}}>In transist</span></>);
            case 5:
                return (<><span style={{color : "#4CAF50"}}>Arrived destination</span></>);
        }
    }

    const dispatchSlip = () => {
        if(order.dispatch_status < 4) {
            return (<><a href={dispatchSlipLink}>Click here to download</a></>);
            // return "NA";
        } else {
            var dispatchSlipLink = `/v1/orders/${order.id}/dispatch_ss`;
            return (<><a href={dispatchSlipLink}>Click here to download</a></>);
        }
    }

    return (
        <Row>
            <Col lg={2}></Col>
            
                <Col lg={8} style={conatinerStyles} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    <Link style={{textDecoration : 'none', color : 'black'}} to={linkToDetailView}>
                        <div>
                            <Row className="odr_cmp">
                                <Col sm={2} md={2} className="text-nowrap">
                                    <span style={{color : 'rgb(255, 215, 0)'}}><b>Order ID : {order.id} </b></span>
                                </Col>
                                <Col className="text-nowrap">
                                    <span><b>Order To Place :</b> {order.order_to}</span>
                                </Col>
                            </Row>
                            <Row className="odr_cmp">
                                <Col sm={6} md={4}>
                                    <span><b>Order Price :</b> {order.order_price - 200}</span>
                                </Col>
                                <Col sm={6} md={4}>
                                    <span><b>Order Quantity :</b> {order.total_quantity}</span>
                                </Col>
                                <Col md={4}>
                                    <span><b>Order Time :</b> {dateTimeConverter(order.order_time)}</span>
                                </Col>
                            </Row>
                            <Row className="odr_cmp">
                                <Col sm={6} md={4}>
                                    <span><b>Payment Status :</b> {paymentStatus()}</span>
                                </Col>
                                <Col sm={6} md={4}>
                                    <span><b>Payment ID :</b> {paymentId()}</span>
                                </Col>
                                <Col md={4}>
                                    <span><b>Dispatch Status :</b> {dispatchStatus()}</span>
                                </Col>
                                {/* <Col md={4}>
                                    <span><b>Payment Status :</b> {paymentConfirmation()}</span>
                                </Col> */}
                            </Row>
                            <Row className="odr_cmp">
                                
                                {/* <Col md={4}>
                                    <span><b>Dispatch Slip :</b> {dispatchSlip()}</span>
                                </Col> */}
                            </Row>
                        </div>
                    </Link>
                </Col>
            
            <Col lg={2}></Col>
        </Row>
    );

}

export default Orders;